<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0">
<!-- <ngx-spinner *ngIf="bln_loading" [fullScreen]="true" bdColor="rgba(0,0,0,0.5)" size="medium" color="#fff"
  type="ball-clip-rotate">
</ngx-spinner> -->

<div class="login-register" style="background-image:url('./assets/images/1.jpg');">

  <app-login *ngIf="str_authenticationType==='NLDAP' || str_authenticationType==='LDAP'"></app-login>


</div>